<div
  class="progress-step-container"
  [ngClass]="{
    'not-Started ': progressStep.state === 'NotStarted',
    'processing-background': progressStep.state === 'Processing',
    'error-background': progressStep.state === 'Error'
  }"
  >
  <div class="progress-step-name">
    <div class="icon">
      @if (progressStep.name === sendingDataToTheCloud) {
        <span
          class="material-symbols-outlined"
          >cloud_upload</span
          >
        }
        @if (progressStep.name === preparingData) {
          <span
            class="material-symbols-outlined"
            >Cycle</span
            >
          }
          @if (progressStep.name === profilingData) {
            <span
              class="material-symbols-outlined"
              >group</span
              >
            }
            @if (progressStep.name === savingProfiledData) {
              <span
                class="material-symbols-outlined"
                >save</span
                >
              }
            </div>
            @if (progressStep.state != 'Error') {
              <div class="status-name">
                {{ progressStep.name }}
              </div>
            }
            @if (progressStep.state === 'Error') {
              <div
                class="error-text status-name"
                i18n="@@seeDetailsBelowError"
                >
      ({{ progressStep.name }}) Error-see below for details
    </div>
            }
          </div>
          <div class="status-name">
            @if (progressStep.state === 'NotStarted') {
              <div class="not-Started">
                <mat-icon>done</mat-icon>
              </div>
            }
            @if (progressStep.state === 'Processing') {
              <div>
                <mat-spinner diameter="25" strokeWidth="2"></mat-spinner>
              </div>
            }
            @if (progressStep.state === 'Completed') {
              <div class="done">
                <mat-icon>done</mat-icon>
              </div>
            }
            @if (progressStep.state === 'Error') {
              <div class="error">
                <mat-icon>close</mat-icon>
              </div>
            }
          </div>
        </div>
